import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconEdit.module.css';

const IconEdit = props => {
  const { rootClassName, className, pencilClassName, size } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (size === "big") {
    return (
      <svg
        className={css.rootBig}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill="#242424"
          d="M19.5 12a.75.75 0 111.5 0v8.25a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V3.75A.75.75 0 013.75 3H12a.75.75 0 110 1.5H4.5v15h15V12z"
        ></path>
        <path
          fill="#242424"
          d="M11.014 12.99l1.238-.177 7.602-7.6a.752.752 0 00.01-1.07.75.75 0 00-1.07.009l-7.604 7.6-.177 1.238h.002zm9.9-9.9a2.25 2.25 0 010 3.183l-7.777 7.777a.75.75 0 01-.425.213l-2.474.354a.75.75 0 01-.85-.849l.354-2.475a.75.75 0 01.212-.424l7.779-7.777a2.25 2.25 0 013.181 0V3.09z"
        ></path>
      </svg>
    );
  } else {
    return (
      <svg className={classes} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <g
          className={pencilClassName || css.pencil}
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5.307 11.155L1 13l1.846-4.308L10.539 1 13 3.461zM11 5L9 3M5 11L3 9" />
        </g>
      </svg>
    );
  }
};

IconEdit.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
};

const { string } = PropTypes;

IconEdit.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
};

export default IconEdit;
